import { render, staticRenderFns } from "./BenefitsCard.vue?vue&type=template&id=5c321cb8&scoped=true"
import script from "./BenefitsCard.vue?vue&type=script&lang=js"
export * from "./BenefitsCard.vue?vue&type=script&lang=js"
import style0 from "./BenefitsCard.vue?vue&type=style&index=0&id=5c321cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c321cb8",
  null
  
)

export default component.exports